function sanitizeClassName(str: string): string {
  try {
    if (!str) return '';
    const decoded = decodeURIComponent(str);
    const sanitized = decoded
      .replace(/[^a-zA-Z0-9]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    return sanitized;
  } catch {
    return '';
  }
}

export function generateUrlClass(url: string | URL): string {
  try {
    const urlObj = typeof url === 'string' ? new URL(url) : url;

    const pathSegments = urlObj.pathname.split('/').filter(Boolean).map(sanitizeClassName);
    const pathClass = pathSegments.join('/');
    const pathSegment = pathClass ? `path-${pathClass}` : '';

    const searchParams = Array.from(urlObj.searchParams.entries()).map(
      ([key, value]) => `param-${sanitizeClassName(key)}-${sanitizeClassName(value)}`
    );

    const hash = urlObj.hash ? [`hash-${sanitizeClassName(urlObj.hash.slice(1))}`] : [];

    return [pathSegment, ...searchParams, ...hash].filter(Boolean).join(' ');
  } catch {
    return '';
  }
}
